import useApiFetch, {apiEndpoint} from '@tracker/shared/src/Auth/Api';
import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {Task} from '../../pages/TimeEntries';

type Props = {
    children : ReactNode,
};

const RecentlyUsedTasksContext = createContext<Task[]>([]);

const RecentlyUsedTasksProvider : React.FC<Props> = ({children} : Props) => {
    const apiFetch = useApiFetch();
    const [recentlyUsedTasks, setRecentlyUsedTasks] = useState<Task[]>([]);

    useEffect(() => {
        (async () => {
            const url = new URL('/v1/tasks/recently-used', apiEndpoint);
            const result = await apiFetch(url.href);

            if (!result.ok) {
                return;
            }

            const data = await result.json();
            setRecentlyUsedTasks(data);
        })();
    }, [setRecentlyUsedTasks, apiFetch]);

    return (
        <RecentlyUsedTasksContext.Provider value={recentlyUsedTasks}>
            {children}
        </RecentlyUsedTasksContext.Provider>
    );
};

export const useRecentlyUsedTasks = () : Task[] => {
    return useContext(RecentlyUsedTasksContext);
};

export default RecentlyUsedTasksProvider;
